import { type FlexflowContractsListFilter } from './hooks';
import { type FilterItem } from 'src/shared/components/Filters/types';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import { useEffect, useMemo } from 'react';
import { FormSpy, useForm } from 'react-final-form';
import Grid2 from '@mui/material/Unstable_Grid2';
import { TextField } from 'src/shared/components/Form/TextField';
import { Filters } from 'src/shared/components/Filters';
import { OnChange } from 'react-final-form-listeners';
import { Box, Hidden } from '@mui/material';

type FormContentProps = {
  filterScheme: FilterItem[];
  setFilterValues: (values: FlexflowContractsListFilter) => void;
  handleChangePage: (event: unknown, newPage: number) => void;
  resetFilters?: () => void | null;
};

export const FormContent = ({ setFilterValues, filterScheme, handleChangePage, resetFilters }: FormContentProps) => {
  const { t } = useTranslation(['filters', 'common', 'history']);
  const form = useForm();

  const debouncedHandleSearch = useMemo(
    () =>
      debounce(searchText => {
        form.change('searchTerm', searchText);
        handleChangePage(undefined, 0);
      }, 300),
    [form, handleChangePage]
  );

  useEffect(() => {
    return () => {
      debouncedHandleSearch.cancel();
    };
  });

  return (
    <>
      <FormSpy<FlexflowContractsListFilter>
        subscription={{ values: true }}
        onChange={({ values }) => {
          setFilterValues(values);
          handleChangePage(undefined, 0);
        }}
      ></FormSpy>
      <Box display="flex" sx={{ gap: 4, alignItems: 'center' }}>
        <Hidden lgDown>
          <Grid2>
            <Filters
              filterScheme={filterScheme}
              resetFilters={resetFilters}
              setFilterValue={values => {
                form.change('filters', values);
              }}
            />
          </Grid2>
        </Hidden>
        <Grid2>
          <TextField
            placeholder={`${t('search by dni', { ns: 'common' })}`}
            name="searchTerm"
            sx={{
              width: 200,
              backgroundColor: '#fff',
              [`& .MuiFormHelperText-root`]: {
                display: 'none'
              }
            }}
          />
          <OnChange name="searchTerm">
            {searchText => {
              debouncedHandleSearch(searchText);
            }}
          </OnChange>
        </Grid2>

        <Hidden lgUp>
          <Grid2>
            <Filters
              filterScheme={filterScheme}
              resetFilters={resetFilters}
              setFilterValue={values => {
                form.change('filters', values);
              }}
            />
          </Grid2>
        </Hidden>
      </Box>
    </>
  );
};
